import { Component } from '@angular/core';
import { UploadDocumentService } from './services/upload-document/upload-document.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from './services/common/common.service';
interface SelectedFile {
  file: File;
  url?: string | ArrayBuffer | null;
  name?: string | null;
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  token: string = '';
  documentType: string = 'step1';
  checkDocumentsData: any
  frontFileType: any = null;
  backFileType: any = null;
  proofOfIncomeFileType: any = null;
  otherDocumentFileType: any = null;
  stateIssueIdFiles: SelectedFile[] = [];
  proofOfIncomeFiles: SelectedFile[] = [];
  otherDocumentFiles: SelectedFile[] = [];
  frontFile: SelectedFile[] = [];
  backFile: SelectedFile[] = [];
  isDragging: boolean;
  uploadView: boolean = true;
  domain: string = 'hansons';

  constructor(
    private uploadService: UploadDocumentService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
  ) {
    const fulldomain = window.location.hostname;
    this.domain = 'hansons';
    if (fulldomain.includes('paramount')) {
      this.domain = 'paramount';
    }
    // const parts = fulldomain.split('.');
    // this.domain = parts.length > 2 ? parts[parts.length - 2] : parts[0];
    // console.log(this.domain);
    this.commonService.presentSpinner();
    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.token = res.token;
      if (this.token) {
        this.uploadView = true;
        this.checkUploadDocuments();
      } else {
        this.uploadView = false;
        this.commonService.dismissSpinner();
      }
    });
  }

  checkUploadDocuments() {
    this.commonService.presentSpinner();
    this.uploadService.checkFinanceDocuments(this.token).then((res: any) => {
      if (res.code == 200) {
        this.checkDocumentsData = res.Data
        if (this.checkDocumentsData) {
          this.documentCheck();
        }
      }
    }).catch(
      (error) => {
        if (error && error.error && error.error.message) {
          // this.commonService.showErrorToastr(error.error.message || error.error.error.message);
          this.uploadView = false;
        } else {
          this.commonService.showErrorToastr('Something went wrong. Please try again or later.');
        }
      }
    ).finally(
      () => {
        this.commonService.dismissSpinner();
      }
    );
  }

  // onDragOver(event: DragEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  // }

  // onDragEnter(event: DragEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.isDragging = true;
  // }

  // onDragLeave(event: DragEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.isDragging = false;
  // }

  // onDrop(event: DragEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.isDragging = false;

  //   const files = event.dataTransfer?.files;
  //   if (files && files.length > 0) {
  //     // Handle dropped files here, for example, you can access the files array and perform actions like displaying them or uploading them.
  //   }
  // }

  onFileSelected(event: any, step: string, stateIssued?: string) {
    const files: FileList | null = event.target.files;
    if (!files || files.length === 0) return;
    for (let i = 0; i < files.length; i++) {
      const file: File | null = files.item(i);
      if (!file) continue;
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const fileType: any = this.getFileType(file.type);
          const fileObject = { file: file, url: reader.result as string, name: file.name };

          switch (step) {
            case 'step1':
              this.handleStep1File(fileObject, stateIssued, fileType);
              break;
            case 'step2':
              this.proofOfIncomeFiles.push(fileObject);
              this.proofOfIncomeFileType = fileType;
              break;
            case 'step3':
              this.otherDocumentFiles.push(fileObject);
              this.otherDocumentFileType = fileType;
              break;
            default:
              console.warn('Unsupported step:', step);
              break;
          }
        } catch (error) {
          console.error('Error processing file:', error);
        }
      };

      if (file.type.startsWith('image/') || file.type === 'application/pdf') {
        reader.readAsDataURL(file); // Read images and PDFs as data URL
      } else {
        console.warn('Unsupported file type:', file.type);
      }
    }
  }

  handleStep1File(fileObject: { file: File, url?: string, name?: string }, stateIssued: string, fileType: any) {
    if (stateIssued === 'front') {
      this.frontFile.push(fileObject);
      this.frontFileType = fileType;
    } else if (stateIssued === 'back') {
      this.backFile.push(fileObject);
      this.backFileType = fileType;
    }
  }

  getFileType(mimeType: string): string {
    if (mimeType.startsWith('image/')) {
      return 'image';
    } else if (mimeType === 'application/pdf') {
      return 'pdf';
    } else {
      throw new Error('Unsupported file type: ' + mimeType);
    }
  }

  deleteUploadedFile(index: number, step: string, stateIssued?: string) {
    try {
      if (step === 'step1') {
        if (stateIssued === 'front' && this.frontFile.length > 0) {
          this.frontFile.pop(); // Remove the last image from the frontFile array
          this.frontFileType = ''; // Clear the file type
        } else if (stateIssued === 'back' && this.backFile.length > 0) {
          this.backFile.pop(); // Remove the last image from the backFile array
          this.backFileType = ''; // Clear the file type
        }
      } else if (step === 'step2') {
        if (this.proofOfIncomeFiles.length > 0) {
          this.proofOfIncomeFiles.splice(index, 1);
          if (!this.proofOfIncomeFiles.length) {
            this.proofOfIncomeFileType = '';
          }
        }
      } else if (step === 'step3') {
        if (this.otherDocumentFiles.length > 0) {
          this.otherDocumentFiles.splice(index, 1);
          if (!this.otherDocumentFiles.length) {
            this.otherDocumentFileType = '';
          }
        }
      } else {
        console.warn('Unsupported step:', step);
      }
    } catch (error) {
      console.error('Error removing image:', error);
    }
  }

  documentCheck() {
    if (this.checkDocumentsData?.stateIssuerIdAck == true && this.checkDocumentsData?.proofOfIncomeAck == false) {
      this.documentType = 'step2';
    } else if (this.checkDocumentsData?.proofOfIncomeAck == true && this.checkDocumentsData?.stateIssuerIdAck == false) {
      this.documentType = 'step1';
    } else if (this.checkDocumentsData?.stateIssuerIdAck == true && this.checkDocumentsData?.proofOfIncomeAck == true) {
      this.documentType = 'step3';
    } else {
      this.documentType = 'step1';
    }
  }

  successMsg: any;
  uploadDocument() {
    if (!(this.proofOfIncomeFiles.length || this.otherDocumentFiles.length || this.frontFile.length || this.backFile.length)) {
      return this.commonService.showErrorToastr('Please upload a document before submitting.');
    } else if ((this.frontFile.length && !this.backFile.length) || (!this.frontFile.length && this.backFile.length)) {
      return this.commonService.showErrorToastr('Please upload both the front and back of your State Issued ID to complete the submission.');
    }
    let formData = new FormData();
    formData.append('token', this.token);
    // formData.append('orderId', this.checkDocumentsData.orderId);
    formData.append('crmAppointmentId', this.checkDocumentsData.crmAppointmentId);
    // formData.append('dbAppointmentId', this.checkDocumentsData.dbAppointmentId);
    this.stateIssueIdFiles = this.frontFile.concat(this.backFile);
    if (this.stateIssueIdFiles && this.stateIssueIdFiles.length) {
      this.stateIssueIdFiles.forEach(file => {
        formData.append('stateIssueIdFiles', file.file);
      });
    }
    if (this.proofOfIncomeFiles && this.proofOfIncomeFiles.length) {
      this.proofOfIncomeFiles.forEach(file => {
        formData.append('proofOfIncomeFiles', file.file);
      });
    }
    if (this.otherDocumentFiles && this.otherDocumentFiles.length) {
      this.otherDocumentFiles.forEach(file => {
        formData.append('otherDocumentFiles', file.file);
      });
    }
    this.commonService.presentSpinner();
    this.uploadService.uploadDocuments(formData).then((res: any) => {
      if (res.code == 200) {
        this.successMsg = res.message
        this.commonService.showSuccessToastr(res.message);
        this.checkUploadDocuments();
        this.frontFile = [];
        this.backFile = [];
        this.stateIssueIdFiles = [];
        this.proofOfIncomeFiles = [];
        this.otherDocumentFiles = [];
        this.frontFileType = '';
        this.backFileType = '';
        this.proofOfIncomeFileType = '';
        this.otherDocumentFileType = '';
      }
    }).catch(
      (error) => {
        if (error && error.error && error.error.message) {
          this.commonService.showErrorToastr(error.error.message || error.error.error.message);
        } else {
          this.commonService.showErrorToastr('Something went wrong. Please try again or later.');
        }
      }
    ).finally(
      () => {
        this.commonService.dismissSpinner();
      }
    );
  }

  preview(step: string) {
    switch (step) {
      case 'step1':
        if (this.checkDocumentsData?.stateIssuerIdAck == true && this.checkDocumentsData?.proofOfIncomeAck == false) {
          this.documentType = 'step2'
        } else {
          this.documentType = step
        }
        break;
      case 'step2':
        if (this.checkDocumentsData?.proofOfIncomeAck == true && this.checkDocumentsData?.stateIssuerIdAck == false) {
          this.documentType = 'step1'
        } else if (this.checkDocumentsData?.stateIssuerIdAck == true && this.checkDocumentsData?.proofOfIncomeAck == true) {
          this.documentType = 'step3'
        } else {
          this.documentType = step
        }
        break;
    }
  }

  saveNext(step: string) {
    switch (step) {
      case 'step1':
        if (this.checkDocumentsData?.stateIssuerIdAck) {
          this.documentType = 'step2'
        } else {
          this.documentType = step
        }
        break;
      case 'step2':
        if (this.checkDocumentsData?.proofOfIncomeAck) {
          this.documentType = 'step3'
        } else {
          this.documentType = step
        }
        break;
      case 'step3':
        this.documentType = step
        break;

      case 'upload':
        this.uploadDocument();
        break;
    }
  }

}
